import React from "react";
import { SegmentDetailsView } from "@tiny/api";

import { Button, Chip } from "@tiny/components";
import PageHeader from "@tiny/components/src/PageHeader";
import { useSuppressionSourceDetailsHeader } from "./SuppressionSourceDetailsHeader.hooks";

export interface SuppressionSourceDetailsHeaderProps {
  title: string;
  suppressionId: string;
  onImport: () => void;
  importDisabled?: boolean;
  enableEdit?: boolean;
  suppressionScope?: string;
}

function SuppressionSourceDetailsHeader(
  props: SuppressionSourceDetailsHeaderProps
) {
  const {
    onImport,
    importDisabled,
    enableEdit = true,
    suppressionScope,
  } = props;

  const {
    editTitle,
    editing,
    saveTitle,
    saving,
    cancelEdit,
    mdUp,
    internalTitle,
    titleEditable,
    chipColor,
  } = useSuppressionSourceDetailsHeader(props);

  return (
    <PageHeader
      mb={mdUp ? 6 : 0}
      backUrl="/main/audience?tab=suppression_list"
      onTitleCancel={cancelEdit}
      onTitleEdit={editTitle}
      onTitleSave={saveTitle}
      title={internalTitle || "-"}
      titleEditLabel="Suppression name"
      titleEditable={titleEditable && enableEdit}
      titleEditing={editing}
      titleMaxLength={140}
      titleSaving={saving}
      chip={<Chip label={suppressionScope} color={chipColor} size="medium" />}
      actions={
        mdUp && (
          <Button
            variant="contained"
            fullWidth
            onClick={onImport}
            disabled={importDisabled}
          >
            Import
          </Button>
        )
      }
    />
  );
}

export default React.memo(SuppressionSourceDetailsHeader);
